export const DEFAULT_SLIPPAGE_BPS = 50;
export const DEBOUNCE_MS = 300;
export const REFRESH_INTERVAL_MS = 10_000; // auto-refresh quotes
export const STATUS_POLL_MS = 5_000;
export const API_URL = import.meta.env.VITE_API_URL ?? "https://api.llamaswap.app";
export const CROSSLLAMA_API_URL = API_URL;
export const SLIPPAGE_PRESETS = [10, 50, 100]; // 0.1%, 0.5%, 1% in bps
export const SLIPPAGE_AUTO = 0; // sentinel: 0 = auto mode
export function resolveSlippage(bps: number, _isCrossChain: boolean): number {
  if (bps !== SLIPPAGE_AUTO) return bps;
  return 50; // 0.5%
}
